import { makeStyles, Tooltip } from '@material-ui/core';

import { ORDER_BY_OPTIONS, OrderByOption } from 'constants/orderBy';

interface OrderByIndicatorProps {
  color?: 'default' | 'warning' | 'error';
  isSelectIndicator?: boolean;
  orderBy?: OrderByOption;
}

const useStyles = makeStyles(({ palette }) => ({
  root: (props: OrderByIndicatorProps) => ({
    width: 13,
    height: 13,
    borderRadius: '100%',
    marginRight: 5,
    zIndex: 1,

    ...(props.color === 'default' && {
      border: `1px solid ${palette.text.primary}`,
    }),
    ...(props.color === 'warning' && {
      backgroundColor: palette.warning.main,
    }),
    ...(props.color === 'error' && {
      backgroundColor: palette.error.main,
    }),

    ...(props.isSelectIndicator && {
      width: 15,
      height: 15,
      position: 'absolute',
      top: -3,
      right: -5,
      marginRight: 0,
    }),
  }),
  tooltip: {
    fontSize: 11,
  },
}));

function OrderByIndicator({
  orderBy,
  color = 'default',
  isSelectIndicator,
}: OrderByIndicatorProps) {
  const classes = useStyles({ color, isSelectIndicator });
  return isSelectIndicator ? (
    <Tooltip
      title={
        orderBy && orderBy === ORDER_BY_OPTIONS.UNREAD
          ? 'Fila ordenada por mensagens não lidas'
          : 'Fila ordenada por última mensagem do contato'
      }
      classes={{ tooltip: classes.tooltip }}
      arrow
    >
      <div className={classes.root} />
    </Tooltip>
  ) : (
    <div className={classes.root} />
  );
}

export default OrderByIndicator;
